import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";

/**
 * Statuses that are not offered as filter options. This is a UI-only trim: orders in these states
 * are still returned by the API and still render their own status label in the table. Remove a
 * status from this list to bring its option back.
 */
export const HIDDEN_ORDER_STATUSES: string[] = [
  OrderStatusEnum.AWAITING_WEEKLY_INVOICING,
  OrderStatusEnum.AWAITING_MONTHLY_INVOICING,
  OrderStatusEnum.AWAITING_QUARTERLY_INVOICING,
];
